"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getPersonalEditorialCategoryOrPageData = void 0;
var _presentationHttp = require("@ori/presentation-http");
var _staticApiClientReact = require("@ori/static-api-client-react");
var _getPersonalEditorialCategoryOrPage = require("./getPersonalEditorialCategoryOrPage");
// istanbul ignore file @preserve -- api
/**
 * Function calls fetch functions and returns data needed for personal editorial landing page.
 */ const getPersonalEditorialCategoryOrPageData = async (param)=>{
    let { applicationName, atpClusterId, language, customerTypeId, graphQlUrl, pageId, previewMode, staticApiUrl, tenant, token, landingPageId, includeRoot, includeThemeItems } = param;
    const staticApiClient = new _staticApiClientReact.ApiClient({
        baseUrl: staticApiUrl,
        language,
        tenant
    });
    const headers = (0, _presentationHttp.getHeaders)({
        sourceAppName: applicationName,
        language,
        tenant,
        token,
        atpClusterId,
        customerTypeId
    });
    const [breadcrumbs, editorialCategoryOrPageData, { data: productBoxConfiguration }] = await Promise.all([
        (0, _presentationHttp.getBreadcrumbs)({
            language,
            pageId,
            staticApiClient,
            tenant
        }),
        (0, _getPersonalEditorialCategoryOrPage.getPersonalEditorialCategoryOrPage)({
            graphQlUrl,
            headers,
            pageId,
            previewMode,
            landingPageId,
            includeRoot,
            includeThemeItems
        }),
        (0, _staticApiClientReact.getTenantApplicationsProductboxConfiguration)(staticApiClient, tenant)
    ]);
    return {
        breadcrumbs,
        editorialCategoryOrPageData,
        productBoxConfiguration
    };
};
exports.getPersonalEditorialCategoryOrPageData = getPersonalEditorialCategoryOrPageData;
